import { OffHoursRecommendationsChartColors } from "@/components/pages/recommendations/components/off-hours-recommendations/utils/constants/constants";
import { OffHoursRecommendationsChartData } from "@/components/pages/recommendations/components/off-hours-recommendations/utils/types/types";

export const generateOffHoursHighChartData = (
  data: OffHoursRecommendationsChartData[],
  withDbConnections: boolean,
) => {
  const categories = data.map((item) => item.timestamp);
  const cpuData = data.map((item) => item.cpu);
  const dbConnectionsData = withDbConnections
    ? data.map((item) => item.database_connections)
    : [];
  const recommendedHoursData = data.map((item) => item.recommendedHours);

  return {
    categories,
    series: [
      {
        name: offHoursChartLabels.cpu,
        data: cpuData,
        color: OffHoursRecommendationsChartColors.CpuArea,
        type: "area",
        fillOpacity: 0.5,
        yAxis: 0,
        showInLegend: false,
        states: { inactive: { enabled: false } },
      },
      ...(withDbConnections
        ? [
            {
              name: offHoursChartLabels.dbConnections,
              data: dbConnectionsData,
              color: OffHoursRecommendationsChartColors.DbConnectionsArea,
              type: "area",
              fillOpacity: 0.5,
              yAxis: 1,
              showInLegend: false,
              states: {
                inactive: { enabled: false },
              },
            },
          ]
        : []),
      {
        name: offHoursChartLabels.recommendedHours,
        data: recommendedHoursData,
        color: OffHoursRecommendationsChartColors.HighlightedArea,
        type: "area",
        fillOpacity: 0.5,
        step: true,
        lineWidth: 0,
        yAxis: 0,
        showInLegend: false,
        states: { inactive: { enabled: false }, hover: { enabled: false } },
      },
    ],
  };
};

export const offHoursChartLabels = {
  cpu: "Maximum CPU Utilization",
  dbConnections: "Database Connections",
  recommendedHours: "Recommended Off Hours",
};
